import request from "@/service";

/* 调动记录列表 */
export function sysUserMoveRecordList(data) {
  return request({
    url: "/user/sysUser/moveRecord/page",
    method: "get",
    params: data
  });
}

// 用户调出
export function saveSysUserMoveRecord(data) {
  return request({
    url: `/user/sysUser/moveRecord/save`,
    method: "post",
    data
  });
}

// 获取审核人列表
export function getAuditUser(data) {
  return request({
    url: `/user/sysUser/moveRecord/getAuditUser/${data}`,
    method: "get"
  });
}
